import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2532">
      <Navbar data-id="element-2533" />
      <main data-id="element-2534">
        <ConsularAffairs data-id="element-2535" />
      </main>
      <Footer data-id="element-2536" />
      <FeedbackPopup data-id="element-2537" />
    </div>;
}